import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import {KeywordClusterList} from "./KeywordClusterList";
import {useTranslation} from "react-i18next";
import {useState} from "react";
import {createKeywordCluster} from "../../../../api/specialization/KeywordSpecializationAPI";
import {PageHeader} from "../../../../components/PageHeader";
import {KeywordClusterListV2} from "./KeywordClusterListV2";
import TrendzContainerCard from "../../../../components/TrendzContainerCard";

export function KeywordClusterPage() {
  const {t} = useTranslation(["common", "keyword"]);
  const [clusterFormName, setClusterFormName] = useState("");
  const [relatedKeywordsForm, setRelatedKeywordsForm] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  const handleSubmit = () => {
    var relatedKeywords = relatedKeywordsForm.split(",");
    relatedKeywords = relatedKeywords.map((keyword) => {
      return keyword.trim();
    });
    createKeywordCluster(clusterFormName, relatedKeywords).then((res) => {
      window.location.reload();
    });
  };

  const onCloseDialog = () => {
    setOpenDialog(false);
  };
  return (
    <TrendzContainerCard
      title={t("keyword:cluster_list")}
    >
      <Grid>
        <Box
          display={"flex"}
          justifyContent={"flex-begin"}
          marginBottom={"20px"}
        >
          <Button
            variant="contained"
            color="success"
            style={{width: "120px", marginRight: "30px"}}
            onClick={() => setOpenDialog(true)}
          >
            {t("common:create")}
          </Button>
        </Box>
        <Dialog
          open={openDialog}
          onClose={onCloseDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>{t("keyword:create_cluster")}</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              id="name"
              label={t("common:name")}
              placeholder={t("keyword:choose_representative_name").toString()}
              fullWidth
              required
              variant="standard"
              onChange={(e) => {
                setClusterFormName((e.target as HTMLInputElement).value);
              }}
            ></TextField>
            <TextField
              margin="dense"
              id="name"
              label={t("keyword:related_keywords")}
              placeholder={
                t("keyword:related_keywords").toString() +
                ", " +
                t("keyword:separated_by_comma").toString()
              }
              fullWidth
              variant="standard"
              required
              onChange={(e) => {
                setRelatedKeywordsForm((e.target as HTMLInputElement).value);
              }}
            ></TextField>
            <DialogActions sx={{marginTop: "20px"}}>
              <Button variant="contained" onClick={handleSubmit}>
                Submit
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
        <KeywordClusterListV2/>
      </Grid>
    </TrendzContainerCard>
  );
}
